import { apiUrl } from '../../config/api';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '../../data/mockData.js';
import { useLanguage, withLanguagePrefix } from '../../contexts/LanguageContext';
import { fetchHomepageJson, HOMEPAGE_CACHE_TTL } from '../../utils/homepageApi';
import './CategoriesSection.css';

const CategoriesSection = () => {
  const { language } = useLanguage();
  // 'loading' | 'ready' | 'error'. The count line only shows real numbers:
  // a skeleton while loading, and nothing at all if the request fails.
  const [counts, setCounts] = useState({});
  const [countStatus, setCountStatus] = useState('loading');

  useEffect(() => {
    let active = true;
    fetchHomepageJson(apiUrl('/api/category-counts'), { ttlMs: HOMEPAGE_CACHE_TTL.categories })
      .then((data) => {
        if (!active) return;
        setCounts(data && typeof data === 'object' ? data : {});
        setCountStatus('ready');
      })
      .catch((error) => {
        console.error('Error fetching category counts:', error);
        if (active) setCountStatus('error');
      });
    return () => { active = false; };
  }, []);

  const renderCount = (categoryName) => {
    if (countStatus === 'loading') {
      return <span className="category-count-skeleton" aria-hidden="true" />;
    }
    const count = Number(counts[categoryName]);
    if (countStatus !== 'ready' || !Number.isFinite(count)) return null;
    return <p className="category-count-homepage">{count.toLocaleString('en-US')} available products.</p>;
  };

  return (
    <section className="categories-section">
      <div className="categories-container">
        <div className="categories-header">
          <h2 className="categories-title">
            Main Categories
          </h2>
          <p className="categories-description">
            Find products and supplies for your business, organized by category
          </p>
        </div>

        <div className="categories-grid">
          {categories.map((category) => (
            <Link
              key={category.name}
              to={withLanguagePrefix(`/search?${new URLSearchParams({ sector: category.name, sort: 'relevance' })}`, language)}
              className="category-card"
              aria-label={`Browse ${category.name}`}
            >
              <div
                className="category-image"
                style={{ backgroundImage: `url(${category.image})` }}
              ></div>
              <h3 className="category-name-homepage">{category.name}</h3>
              {renderCount(category.name)}
              <span className="category-link">
                See All →
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoriesSection;
